
import { computed, defineComponent, onMounted, ref } from "vue-demi";
import debounce from "lodash.debounce";

export default defineComponent({
  name: "ScrollContainer",

  emits: ["end-scroll-left", "end-scroll-right"],

  setup(_, { emit, slots }) {
    const hasSlotLeft = computed(() => !!slots.left);

    const hasSlotRight = computed(() => !!slots.right);

    const gridColumns = computed(() => {
      if (hasSlotLeft.value && hasSlotRight.value) return 12;

      return 6;
    });

    const leftContainer = ref<HTMLElement | null>(null);

    const onScrollLeftContainer = debounce(() => {
      if (!leftContainer.value) return;

      const el = leftContainer.value;
      const scrollBottom = el.scrollTop + el.clientHeight;
      const scrollHeight = el.scrollHeight;

      if (scrollBottom >= scrollHeight * 0.85) {
        emit("end-scroll-left");
      }
    }, 200);

    const rightContainer = ref<HTMLElement | null>(null);

    const onScrollRightContainer = debounce(() => {
      if (!rightContainer.value) return;

      const el = rightContainer.value;
      const scrollBottom = el.scrollTop + el.clientHeight;
      const scrollHeight = el.scrollHeight;

      if (scrollBottom >= scrollHeight * 0.85) {
        emit("end-scroll-right");
      }
    }, 200);

    onMounted(() => {
      onScrollLeftContainer();
      onScrollRightContainer();
    });

    return {
      hasSlotLeft,
      gridColumns,
      hasSlotRight,
      leftContainer,
      rightContainer,
      onScrollLeftContainer,
      onScrollRightContainer,
    };
  },
});
